import { BackgroundInfoTopic } from '../background-info-topic';
import { BackgroundInfo } from '../background-info';

export class AddSubtopicModalPayload {
  activeJurisdiction: BackgroundInfo;
  activeTopic: BackgroundInfoTopic;
  useCase: number;
  objectId: number;
  objectName?: string;
}
